import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import DrugBox from './DrugBox'
import { Chip, Grid, Paper, Stack } from '@mui/material'

const KeyItem = ({ color, text }) => (
  <Chip
    size="small"
    label={text}
    sx={{
      borderRadius: 1,
      fontWeight: 800,
      border: `1px solid ${color}33`,
      color,
      backgroundColor: `${color}12`,
      '&::before': {
        content: '""',
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: color,
        ml: 1,
      },
      gap: 0.75,
    }}
  />
)

const Contents = ({
  contentSummary,
  setSelectedMedicines,
  allDrugs,
  requiredDrugs,
  noClick,
  emptyHint,
}) => {
  const [empty, setEmpty] = useState([])
  const checkEmpty = () => {
    const missing = []
    requiredDrugs.forEach((requiredDrug) => {
      const existing = contentSummary.find((x) => x._id === requiredDrug._id)
      if (!existing) {
        missing.push({
          name: requiredDrug.title,
          constitution: requiredDrug.constitution,
          presentation: requiredDrug.presentation,
          qty: 0,
          _id: requiredDrug._id,
          isControlled: requiredDrug.isControlled,
        })
      }
    })
    setEmpty(missing)
  }

  useEffect(() => {
    if (requiredDrugs.length > 0) {
      checkEmpty()
      return
    }

    setEmpty([])
  }, [requiredDrugs, contentSummary])

  const totalRows = contentSummary.length + empty.length

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        borderRadius: 2,
        border: '1px solid rgba(15,23,42,0.08)',
        backgroundColor: '#fff',
      }}
    >
      <Stack spacing={1.5}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'center' }}
          spacing={1}
        >
          <Stack spacing={0.25}>
            <Typography fontWeight={950}>Contents</Typography>
            <Typography variant="caption" color="text.secondary">
              {totalRows} medicines tracked
              {!noClick && totalRows > 0
                ? ' — select a medicine to move it, assign it to a bag, or remove stock'
                : ''}
            </Typography>
          </Stack>

          <Stack direction="row" gap={0.75} flexWrap="wrap" useFlexGap>
            <KeyItem color="#16A34A" text="Good" />
            <KeyItem color="#DC2626" text="Out of date" />
            <KeyItem color="#D97706" text="Expiring" />
            <KeyItem color="#0891B2" text="Low stock" />
          </Stack>
        </Stack>

        {totalRows === 0 ? (
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: '1px dashed rgba(15,23,42,0.16)',
              backgroundColor: '#F8FAFC',
            }}
          >
            <Typography fontWeight={900}>No medicines recorded.</Typography>
            <Typography variant="body2" color="text.secondary">
              {emptyHint || 'Stock added to this location will appear here.'}
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={1}>
            {contentSummary.map((drug) => (
              <DrugBox
                key={drug._id}
                drug={drug}
                onClick={() =>
                  !noClick &&
                  setSelectedMedicines(
                    allDrugs.filter((x) => x.medicine._id === drug._id),
                  )
                }
              />
            ))}
            {empty.map((drug) => (
              <DrugBox
                key={drug._id}
                drug={drug}
                onClick={() =>
                  !noClick &&
                  setSelectedMedicines(
                    allDrugs.filter((x) => x.medicine._id === drug._id),
                  )
                }
              />
            ))}
          </Grid>
        )}
      </Stack>
    </Paper>
  )
}

export default Contents
